<template>
    <div class="container">
        <el-tabs
                class="hidden-sm-and-down "
                v-model="activeName"
        >
            <el-tab-pane
                    v-for="(item2, index2) in hxContentList"
                    :key="index2"
                    :label="item2.optionTitle"
                    :name="index2 + ''"
            >
                <!--                <div class="tab">-->
                <el-row class="ordinary" :gutter="39">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="positionRight">
                        <!--                        <div class="grid-content" style="display: flex;justify-content: right">-->
                        <!--                            <el-image :src="item2.url" class="image"></el-image>-->
                        <!--                        </div>-->
                        <div class="bigDiv">
                            <img :src="item2.url">
                        </div>

                    </el-col>

                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="positionLeft">
                        <div class="contenrtDiv" >
                            <div style="height: 20%;width:100%;display: flex;justify-content: space-between;align-items: center">
                                <div style="display: flex;align-content: center;flex-direction: column;justify-content: space-around">

                                    <div v-if="item2.title"
                                         style="color: #333;font-size: 18px;color: #409EFF;">
                                        {{ item2.title }}
                                    </div>
                                    <div
                                            v-if="item2.subtitle"
                                            style=" font-size: 14px;line-height: 26px;color: #999;"
                                    >
                                        {{ item2.subtitle }}
                                    </div>
                                </div>
                                <div v-if="item2.isButton === '1'">
                                    <el-button
                                            @click="jump(item2.buttonUrl)"

                                            type="primary"
                                            size="mini"
                                    >{{ item2.buttonText }}
                                    </el-button>
                                    <!--                                style="display: inline-block;position: absolute;bottom: 0"-->
                                </div>
                            </div>

                            <div
                                    class="ql-editor firstLine"
                                    style="color: #333;height: 80%;font-size: 14px;padding: 0; line-height: 28px; "
                                    v-if="item2.content"
                                    v-html="item2.content"
                            ></div>
                        </div>
                    </el-col>
                </el-row>
                <!--                </div>-->
            </el-tab-pane>
        </el-tabs>
        <el-tabs
                class="hidden-sm-and-up"
                v-model="activeName"
        >
            <el-tab-pane
                    v-for="(item2, index2) in hxContentList"
                    :key="index2"
                    :label="item2.optionPhoneTitle"
                    :name="index2 + ''"
            >
                <div>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div>
<!--                                <el-image-->
<!--                                        style="width: 100%; height: 200px;"-->
<!--                                        :src="item2.url"-->
<!--                                ></el-image>-->
                                <div class="bigDiv">
                                    <img :src="item2.url">
                                </div>
                            </div>
                        </el-col>

                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div>
                                <div v-if="item2.title"
                                     style="color: #333;font-size: 18px;font-weight: bold;margin-top: 10px">
                                    {{ item2.title }}
                                </div>
                                <div
                                        v-if="item2.subtitle"
                                        style=" font-size: 14px;line-height: 26px;color: #999;margin: 10px 0"
                                >
                                    {{ item2.subtitle }}
                                </div>
                                <div
                                        class="about-us-content-title-content ql-editor firstLine"
                                        style="color: #333;font-size: 12px;padding:0"
                                        v-if="item2.content"
                                        v-html="item2.content"
                                ></div>
                                <div v-if="item2.isButton === '1'">
                                    <el-button
                                            
                                            @click="jump(item2.buttonUrl)"
                                            style="display: inline-block;margin-top: 10px"
                                            type="primary"
                                    >{{ item2.buttonText }}
                                    </el-button>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    export default {
        name: "tabs-index",
        props: {
            hxContentList: Array
        },
        data() {
            return {
                activeName: "0",
            }
        },
        methods: {
            // 按钮跳转
            jump(url) {
                window.open(url);
            },
        }
    }
</script>

<style lang="scss">

    .scal {
        overflow: hidden;

        img {
            transition: all .3s;
        }

        &:hover img {
            transform: scale(1.1);
        }
    }

    /*首行缩进*/
    .firstLine {
        text-indent: 2em;
        line-height: 28px;

    }

    .tab {
        display: flex;
        justify-content: center;
        height: 350px;
        width: 100%;
        margin: 0 10px;
    }

    .el-tabs__header {
        display: flex;
        justify-content: center;
    }

    @media screen and (min-width: 1400px) {
        .tab {
            .image {
                height: 350px;
                width: 60%;
            }
        }


    }

    @media screen and (max-width: 1200px) {
        .tab {
            .image {
                height: 350px;
                width: 90%;
            }
        }

    }

    @media screen and (max-width: 870px) {

    }

    @media screen and (max-width: 570px) {
        /*.firstLine{*/
        /*    padding: 0 25px 0 25px!important;*/
        /*}*/
    }
</style>
<style lang="scss" scoped>
    .contenrtDiv {
        /*width: 100%;*/
        width: 100%;
        aspect-ratio: 15/8;
    }

    .bigDiv {
        position: relative;
        overflow: hidden;
        /*width: 80%;*/
        aspect-ratio: 15/8;
        /*height: 350px;*/
    }

    .bigDiv img {
        /*height: 100%;*/
        width: 100%;
        transition: all .3s;

        /*height: 100%;*/
    }

    .bigDiv:hover img {
        transform: scale(1.1);
    }

    .ordinary {
        display: flex;
        justify-content: center;
        overflow-y: hidden;
    }

    .positionRight {
        display: flex;
        justify-content: right;
    }

    .positionLeft {
        display: flex;
        justify-content: left;
    }

    @media screen and (max-width: 994px) {
        .positionLeft {
            justify-content: center;
        }
        .positionRight {
            justify-content: center;
        }
    }

    .firstLine {
        padding: 0;
    }
</style>
